export default __webpack_public_path__ + "static/media/private_accelerator.c8eff00d.svg";